import BaseModule from "./base-module";
class Store extends BaseModule {
  getStoreInfo(params) {
    return this.get("/v1/store", { params });
  }
  getStoreMainBusiness(params) {
    return this.get("/v1/store/mainBusiness", { params });
  }
  getStorePayment(params) {
    return this.get("/v1/store/paymethod", { params });
  }
  getAllCoupons(params) {
    return this.get("/v1/store/coupon/all", { params });
  }
  getAllStore(params) {
    return this.get("/v1/stores", { params });
  }
  getThemeColor(params) {
    return this.get("/v1/color", { params });
  }
  getZipcodeStore(params) {
    return this.gett("/v1/zipcode/stores", { params });
  }
  getBanner(params) {
    return this.get("/v1/banner", { params });
  }
  getPages(params) {
    return this.get("/v1/store/pages", { params });
  }
  getStart(params) {
    return this.get("/v1/show/start", { params });
  }
  getFacebook(params) {
    return this.get("/v1/facebook", { params });
  }
  getCopyRight(params) {
    return this.get("/v1/webCopyright", { params });
  }
  getHelpList(params) {
    return this.get("/v1/copywritingSetting?type=1", { params });
  }
  getRegisterAggreement(params) {
    return this.get("/v1/copywritingSetting?type=2", { params });
  }
}

export default new Store();
